import React from "react";
import { useFormContext } from "react-hook-form";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../components/forms/TextInput";
import SelectInput from "../../../components/forms/SelectInput";
import { validationMode } from "../../../config/helpers";
import FileUploadField from "./FileUploadField";
import { IFormInscription } from "./types";
import AddressAutocomplete from "../../../components/forms/AddressAutocomplete";

interface SectionSocieteProps {
  isPaysLoading: boolean;
  pays: any;
  isFranceOrAssimile: boolean;
}

const SectionSociete: React.FC<SectionSocieteProps> = ({
  isPaysLoading,
  pays,
  isFranceOrAssimile,
}) => {
  const { setValue } = useFormContext<IFormInscription>();

  return (
    <CpntFormSection pSectionLabel="INFORMATIONS SUR VOTRE SOCIÉTÉ">

      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <SelectInput
          label="Pays"
          formName="IdPays"
          ismandatory={true}
          optionEmpty="Sélectionnez un pays"
          validationStyle={validationMode.classic}
          options={
            isPaysLoading
              ? []
              : pays?.Pays?.map((p: any) => ({
                  Id: p.Id,
                  Libelle: p.Libelle,
                })) || []
          }
        />
      </CpntFormSectionContainer>

      {isFranceOrAssimile && (
        <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
          <TextInput
            label="N° Siren"
            formName="Siren"
            ismandatory={true}
            validationStyle={validationMode.classic}
            placeholder="Numéro SIREN (9 chiffres)"
          />
          <TextInput
            label="Raison sociale (SIREN)"
            formName="RaisonSocialeSiren"
            validationStyle={validationMode.classic}
            placeholder="Récupérée automatiquement"
            disabled={true}
          />
        </CpntFormSectionContainer>
      )}

      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <TextInput
          label="Raison sociale"
          formName="RaisonSociale"
          ismandatory={true}
          validationStyle={validationMode.classic}
          placeholder="Raison sociale"
        />
      </CpntFormSectionContainer>

      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <TextInput
          label="Site internet"
          formName="SiteInternet"
          validationStyle={validationMode.classic}
          placeholder="https://www.example.com"
        />
      </CpntFormSectionContainer>

      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        {isFranceOrAssimile ? (
          <AddressAutocomplete ismandatory validationStyle={validationMode.classic} />
        ) : (
          <TextInput
            label="Adresse"
            formName="Adresse"
            ismandatory={true}
            validationStyle={validationMode.classic}
            placeholder="Adresse"
          />
        )}
      </CpntFormSectionContainer>

      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6]}>
        <TextInput
          label="Code postal"
          formName="CodePostal"
          validationStyle={validationMode.classic}
          placeholder="Code postal"
          maxLength={11}
          onchange={isFranceOrAssimile ? (value) => setValue("CodePostal", value, { shouldValidate: true, shouldTouch: true }) : undefined}
        />
        <TextInput
          label="Ville"
          formName="Ville"
          ismandatory={true}
          validationStyle={validationMode.classic}
          placeholder="Ville"
          onchange={isFranceOrAssimile ? (value) => setValue("Ville", value, { shouldValidate: true, shouldTouch: true }) : undefined}
        />
      </CpntFormSectionContainer>

      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[12]}>
        <FileUploadField />
      </CpntFormSectionContainer>

    </CpntFormSection>
  );
};

export default SectionSociete;
